import { useSelector } from 'react-redux';
import useTranslate from 'hooks/useTranslate';
import { CookieConsentVersion } from 'constants/consent';
import { BUSINESS_TERMS_OF_SALE_URL, BUSINESS_TERMS_URL, COOKIE_POLICY_URL, OUR_PLATFORM_URL, PRIVACY_POLICY_URL, TERMS_URL } from 'constants/routes';
import { getOldHostRedirectUrl } from 'libs/utils/url';
import { toggleOneTrustInfoDisplay } from 'libs/utils/window';
import * as consentSelectors from 'state/consent/selectors';
import SectionLink from './SectionLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const PrivacySection = _ref => {
  let {
    isDigitalLawEnabled,
    isBusinessInfoLinksEnabled,
    onlineComplaintUrl
  } = _ref;
  const translate = useTranslate('footer.policy.items');
  const isCookieConsentVersion = useSelector(consentSelectors.getIsCookieConsentVersion);
  const cookieConsentVersion = useSelector(consentSelectors.getCookieConsentVersion);

  const handleCookieSettingsClick = () => {
    toggleOneTrustInfoDisplay();
  };

  const cookieSettingsText = cookieConsentVersion === CookieConsentVersion.California ? translate('cookie_settings_us') : translate('cookie_settings');
  return /*#__PURE__*/_jsxs("ul", {
    className: "main-footer__privacy-section",
    children: [/*#__PURE__*/_jsx(SectionLink, {
      text: translate('privacy_policy'),
      url: getOldHostRedirectUrl() + PRIVACY_POLICY_URL
    }), /*#__PURE__*/_jsx(SectionLink, {
      text: translate('cookie_policy'),
      url: COOKIE_POLICY_URL
    }), isCookieConsentVersion && /*#__PURE__*/_jsx("li", {
      className: "main-footer__privacy-section-item",
      children: /*#__PURE__*/_jsx("button", {
        className: "main-footer__privacy-section-link",
        type: "button",
        onClick: handleCookieSettingsClick,
        children: cookieSettingsText
      })
    }), /*#__PURE__*/_jsx(SectionLink, {
      text: translate('terms_and_conditions'),
      url: TERMS_URL
    }), isDigitalLawEnabled && /*#__PURE__*/_jsx(SectionLink, {
      text: translate('our_platform'),
      url: OUR_PLATFORM_URL
    }), isBusinessInfoLinksEnabled && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(SectionLink, {
        text: translate('pro_terms_of_sale'),
        url: BUSINESS_TERMS_OF_SALE_URL,
        testId: "privacy-footer-pro-sale-term-link"
      }), /*#__PURE__*/_jsx(SectionLink, {
        text: translate('pro_terms_of_use'),
        url: BUSINESS_TERMS_URL,
        testId: "privacy-footer-pro-use-term-link"
      })]
    }), onlineComplaintUrl && /*#__PURE__*/_jsx(SectionLink, {
      text: translate('online_complaints'),
      url: onlineComplaintUrl
    })]
  });
};

export default PrivacySection;